export default __webpack_public_path__ + "static/media/TV.53311457.jpg";